<script setup lang="ts">
defineOptions({ inheritAttrs: false })

withDefaults(defineProps<{
  size?: 'lg' | 'md' | 'sm'
  variant?: 'ghost' | 'primary'
}>(), {
  size: 'md',
  variant: 'primary',
})
</script>

<template>
  <UButton
    :variant="variant === 'primary' ? 'solid' : 'outline'"
    color="primary"
    :size="size"
    v-bind="$attrs"
  >
    <template v-for="(_, name) in $slots" #[name]="slotData">
      <slot :name="name" v-bind="slotData ?? {}"/>
    </template>
  </UButton>
</template>
